<div class="import-cleared-checks" *ngIf="importEnabled">
	<sl-file-upload [allowedExtensions]="['.txt', '.csv']" (fileUploaded)="fileChangeEvent($event)" readAsText="true" buttonText="Import"
		buttonType="icon">
	</sl-file-upload>
</div>
